import React, { useEffect, useState } from 'react';
import useToken from 'hooks/useToken';
import DatePicker from "react-datepicker";
import { Col, Row, Container, Spinner, Form } from 'react-bootstrap';
import { useToast } from 'context/providers/ToastProvider';

const ResumenMensualImpuestos = () => {

    const { token, setToken } = useToken();
    const { showErrorToast } = useToast();

    const [dateQuarter, setDateQuarter] = useState(new Date());

    const [cargando, setCargando] = useState(false);

    const [facturasEmitidas, setFacturasEmitidas] = useState([]);
    const [egresoEmitidas, setEgresoEmitidas] = useState({});
    const [pagoEmitidas, setPagoEmititdas] = useState({});
    const [rfc, setRFC] = useState([]);
    const [selectedRfc, setSelectedRfc] = useState("");

    const [facturasRecibidas, setFacturasRecibidas] = useState([]);
    const [egresoRecibidas, setEgresoRecibidas] = useState({});
    const [pagoRecibidas, setPagoRecibidas] = useState({});
    const [informe, setInforme] = useState({});


    useEffect(() => {
        obtenerRfcReceptor();

    }, []);

    useEffect(() => {
        ObtenerDatosImpuestos();

    }, [selectedRfc]);


    /**
     * Función para manejar el cambio de fecha
     */
    const handleDateChange = (date) => {
        setDateQuarter(date);
        sessionStorage.setItem("selectMes", date);
        ObtenerDatosImpuestos();
    };

    /**
    * Funcion para obtener los rfc para el filtro
    */
    const obtenerRfcReceptor = async () => {

        const response = await fetch("/api/FacturasEmitidas/ObtenerRFCReceptor",
            {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);

            });

        if (response.ok) {
            setCargando(false);
            const data = await response.json();

            if (data.iResponseType == 1) {

                var ObjDetalles = JSON.parse(data.detalles);

                setRFC(ObjDetalles.table2);

                setSelectedRfc(ObjDetalles.table2[0].vRFC);


            } else {
                showErrorToast(data.vMessage);
            }

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    };

    /**
     * Obtiene los Datos de los Gastos
     */
    const ObtenerDatosImpuestos = async () => {
        console.log(dateQuarter)
        setCargando(true);

        var date_ = sessionStorage.getItem("selectMes") == null ? dateQuarter : sessionStorage.getItem("selectMes");

        setDateQuarter(new Date(date_));

        var month = new Date(date_).getMonth() + 1;
        var year = new Date(date_).getFullYear();

        // Asegura que el mes tenga siempre 2 dígitos (ej. 02, 03, ..., 12)
        var formattedMonth = month < 10 ? '0' + month : '' + month;

        const data = {
            year: '' + year,
            month: formattedMonth,
            rfc: selectedRfc
        };

        console.log("fecha enviada", data);


        const response = await fetch("/api/Impuestos/ObtenerDatosImpuestos",
            {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                console.log('Hubo un problema con la peticion Fetch:' + error);

            });

        if (response.ok) {

            console.log("==== OBTENER DATOS FACTURAS ====");

            const data = await response.json();

            if (data.iResponseType == 1) {


                var ObjDetalles = JSON.parse(data.detalles);

                console.log("ImpuestosDATA", ObjDetalles);


                setFacturasEmitidas(ObjDetalles.table2);
                setEgresoEmitidas(ObjDetalles.table3[0]);
                setPagoEmititdas(ObjDetalles.table4[0]);


                setFacturasRecibidas(ObjDetalles.table5);
                setEgresoRecibidas(ObjDetalles.table6[0]);
                setPagoRecibidas(ObjDetalles.table7[0]);

                setInforme({
                    ...ObjDetalles.table8[0],
                    ...ObjDetalles.table9[0],
                    ...ObjDetalles.table10[0]
                });

            } else {
                showErrorToast(data.vMessage);
            }
            setCargando(false);



        }
        else {
            setCargando(true);
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    };
    console.log(informe)


    return (
        <Container fluid className="bg-white rounded-3 shadow-sm p-3">
            {/* Encabezado mejorado */}
            <Row className="align-items-center mb-4">
                <Col xs={6} md={8}>
                    <div className="d-flex align-items-center">
                        <div>
                            <h5 className="fw-bold mb-0">Resumen de Facturación</h5>
                            <span className="text-muted small">Total consolidado del período</span>
                        </div>
                    </div>
                </Col>
                <Col xs={6} md={2}>
                    <div className="d-flex flex-column align-items-end">
                        <label htmlFor="date-picker" className="mb-1">Mes</label>
                        <DatePicker
                            selected={dateQuarter}
                            dateFormat="MMMM yyyy - QQQ"
                            className="form-control w-100"
                            showMonthYearPicker
                            onChange={handleDateChange}
                            id="date-picker"
                        />
                    </div>
                </Col>
                <Col xs={6} md={2}>
                    <div className="d-flex flex-column align-items-end">
                        <label htmlFor="date-picker" className="mb-1">RFC</label>
                        <Form.Select
                            size="xs"
                            value={selectedRfc}
                            onChange={(e) => setSelectedRfc(e.target.value)}
                            className="form-control form-control-sm w-100"
                        >
                            {rfc.map((item, index) => (
                                <option key={index} value={item.vRFC}>
                                    {item.vRFC}
                                </option>
                            ))}
                        </Form.Select>
                    </div>
                </Col>
            </Row>

            {cargando ? (
                <h5>
                    <Spinner className="text-inline" animation="border" variant="primary" /> Cargando...
                </h5>
            ) : (
                <Row className="g-3">
                    {/* Sección INGRESO */}
                        <Col md={12}>
                            <div className="border rounded shadow-sm">
                                <h6 className="fw-bold p-2 bg-light border-bottom mb-0">FACTURAS EMITIDAS</h6>
                                <div className="p-2">
                                    {/* Primera fila con PUE y PPD */}
                                    <Row className="mb-3">
                                        {/* Columna PUE */}
                                        <Col md={6} className="pe-1">
                                            <div className="border p-2 bg-white rounded">
                                                <small className="d-block fw-bold text-uppercase text-primary mb-2">PUE - Pago en una exhibición - INGRESO</small>

                                                <div className="d-flex justify-content-between small fw-bold">
                                                    <span className="text-secondary">Subtotal:</span>
                                                    <span className="fw-semibold">
                                                        {(facturasEmitidas.find(f => f.vMetodoPago === "PUE")?.dTotalSubTotal || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                    </span>
                                                </div>
                                                <div className="d-flex justify-content-between small fw-bold border-top pt-1">
                                                    <span className="text-secondary">Descuento:</span>
                                                    <span className="fw-semibold">
                                                        {(facturasEmitidas.find(f => f.vMetodoPago === "PUE")?.dDescuento || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                    </span>
                                                </div>

                                                {/* Impuestos Trasladados desglosados */}
                                                <div className="mt-2">
                                                    <div className="d-flex justify-content-between small">
                                                        <span className="text-secondary">IVA:</span>
                                                        <span className="fw-semibold">
                                                            {(facturasEmitidas.find(f => f.vMetodoPago === "PUE")?.dIva || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                        </span>
                                                    </div>
                                                    <div className="d-flex justify-content-between small">
                                                        <span className="text-secondary">IEPS:</span>
                                                        <span className="fw-semibold">
                                                            {(facturasEmitidas.find(f => f.vMetodoPago === "PUE")?.dIEPS || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                        </span>
                                                    </div>
                                                </div>

                                                {/* Impuestos Retenidos desglosados */}
                                                <div className="mt-2">
                                                    <div className="d-flex justify-content-between small">
                                                        <span className="text-secondary">IVA RET:</span>
                                                        <span className="fw-semibold">
                                                            {(facturasEmitidas.find(f => f.vMetodoPago === "PUE")?.dIvaRetenido || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                        </span>
                                                    </div>
                                                    <div className="d-flex justify-content-between small">
                                                        <span className="text-secondary">ISR RET:</span>
                                                        <span className="fw-semibold">
                                                            {(facturasEmitidas.find(f => f.vMetodoPago === "PUE")?.dIsrRetenido || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                        </span>
                                                    </div>
                                                </div>

                                                <div className="d-flex justify-content-between fw-bold small border-top pt-1">
                                                    <span className="text-secondary">Total Impuestos Trasladados:</span>
                                                    <span className="fw-semibold">
                                                        {(facturasEmitidas.find(f => f.vMetodoPago === "PUE")?.dTotalImpuestosTrasladados || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                    </span>
                                                </div>
                                                <div className="d-flex justify-content-between small fw-bold border-top pt-1">
                                                    <span className="text-secondary">Total Impuestos Retenidos:</span>
                                                    <span className="fw-semibold">
                                                        {(facturasEmitidas.find(f => f.vMetodoPago === "PUE")?.dTotalImpuestosRetenidos || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                    </span>
                                                </div>

                                                <div className="d-flex justify-content-between border-top pt-1 mt-1 fw-bold">
                                                    <span>Total:</span>
                                                    <span className="text-dark">
                                                        {(facturasEmitidas.find(f => f.vMetodoPago === "PUE")?.dTotal || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                    </span>
                                                </div>
                                            </div>
                                        </Col>

                                        {/* Columna PPD */}
                                        <Col md={6} className="ps-1">
                                            <div className="border p-2 bg-white rounded">
                                                <small className="d-block fw-bold text-uppercase text-primary mb-2">PPD - Pago parcialidades - INGRESO</small>

                                                <div className="d-flex justify-content-between small fw-bold">
                                                    <span className="text-secondary">Subtotal:</span>
                                                    <span className="fw-semibold">
                                                        {(facturasEmitidas.find(f => f.vMetodoPago === "PPD")?.dTotalSubTotal || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                    </span>
                                                </div>
                                                <div className="d-flex justify-content-between small fw-bold border-top pt-1">
                                                    <span className="text-secondary">Descuento:</span>
                                                    <span className="fw-semibold">
                                                        {(facturasEmitidas.find(f => f.vMetodoPago === "PPD")?.dDescuento || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                    </span>
                                                </div>

                                                {/* Impuestos Trasladados desglosados */}
                                                <div className="mt-2">
                                                    <div className="d-flex justify-content-between small">
                                                        <span className="text-secondary">IVA:</span>
                                                        <span className="fw-semibold">
                                                            {(facturasEmitidas.find(f => f.vMetodoPago === "PPD")?.dIva || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                        </span>
                                                    </div>
                                                    <div className="d-flex justify-content-between small">
                                                        <span className="text-secondary">IEPS:</span>
                                                        <span className="fw-semibold">
                                                            {(facturasEmitidas.find(f => f.vMetodoPago === "PPD")?.dIEPS || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                        </span>
                                                    </div>
                                                </div>

                                                {/* Impuestos Retenidos desglosados */}
                                                <div className="mt-2">
                                                    <div className="d-flex justify-content-between small">
                                                        <span className="text-secondary">IVA RET:</span>
                                                        <span className="fw-semibold">
                                                            {(facturasEmitidas.find(f => f.vMetodoPago === "PPD")?.dIvaRetenido || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                        </span>
                                                    </div>
                                                    <div className="d-flex justify-content-between small">
                                                        <span className="text-secondary">ISR RET:</span>
                                                        <span className="fw-semibold">
                                                            {(facturasEmitidas.find(f => f.vMetodoPago === "PPD")?.dIsrRetenido || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="d-flex justify-content-between small border-top pt-1 fw-bold">
                                                    <span className="text-secondary">Total Impuestos Trasladados:</span>
                                                    <span className="fw-semibold">
                                                        {(facturasEmitidas.find(f => f.vMetodoPago === "PPD")?.dTotalImpuestosTrasladados || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                    </span>
                                                </div>
                                                <div className="d-flex justify-content-between small border-top pt-1 fw-bold">
                                                    <span className="text-secondary">Total Impuestos Retenidos:</span>
                                                    <span className="fw-semibold">
                                                        {(facturasEmitidas.find(f => f.vMetodoPago === "PPD")?.dTotalImpuestosRetenidos || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                    </span>
                                                </div>
                                                <div className="d-flex justify-content-between border-top pt-1 mt-1 fw-bold">
                                                    <span>Total:</span>
                                                    <span className="text-dark">
                                                        {(facturasEmitidas.find(f => f.vMetodoPago === "PPD")?.dTotal || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                    </span>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>

                                    {/* Segunda fila con EGRESO y PAGO */}
                                    <Row>
                                        {/* Columna EGRESO */}
                                        <Col md={6} className="pe-1">
                                            <div className="border p-2 bg-white rounded">
                                                <small className="d-block fw-bold text-uppercase text-primary mb-2">EGRESO - PUE - PPD</small>

                                                <div className="d-flex justify-content-between small fw-bold">
                                                    <span className="text-secondary">Subtotal:</span>
                                                    <span className="fw-semibold">
                                                        {(egresoEmitidas?.dTotalSubTotal || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                    </span>
                                                </div>
                                                <div className="d-flex justify-content-between small fw-bold border-top pt-1">
                                                    <span className="text-secondary">Descuento:</span>
                                                    <span className="fw-semibold">
                                                        {(egresoEmitidas?.dDescuento || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                    </span>
                                                </div>

                                                <div className="d-flex justify-content-between small border-top pt-1">
                                                    <span className="text-secondary">IVA:</span>
                                                    <span className="fw-semibold">
                                                        {(egresoEmitidas?.dIva || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                    </span>
                                                </div>
                                                <div className="d-flex justify-content-between small">
                                                    <span className="text-secondary">IEPS:</span>
                                                    <span className="fw-semibold">
                                                        {(egresoEmitidas?.dIEPS || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                    </span>
                                                </div>

                                                <div className="d-flex justify-content-between small fw-bold border-top pt-1">
                                                    <span className="text-secondary">Total de impuestos trasladados:</span>
                                                    <span className="fw-semibold">
                                                        {(egresoEmitidas?.dTotalImpuestosTrasladados || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                    </span>
                                                </div>

                                                <div className="d-flex justify-content-between border-top pt-1 mt-1 fw-bold">
                                                    <span>Total:</span>
                                                    <span className="text-dark">
                                                        {(egresoEmitidas?.dTotal || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                    </span>
                                                </div>
                                            </div>
                                        </Col>

                                        {/* Columna PAGO */}
                                        {/* Columna PAGO */}
                                        <Col md={6} className="ps-1">
                                            <div className="border p-2 bg-white rounded" style={{ height: "182px", display: "flex", flexDirection: "column" }}>
                                                <small className="d-block fw-bold text-uppercase text-primary mb-2">REP - RECIBO ELECTRÓNICO DE PAGO</small>

                                                <div className="d-flex justify-content-between small fw-bold">
                                                    <span className="text-secondary">Subtotal Base 16:</span>
                                                    <span className="fw-semibold">
                                                        {(pagoEmitidas?.dSubTotal16 || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                    </span>
                                                </div>
                                                <div className="d-flex justify-content-between small fw-bold">
                                                    <span className="text-secondary">Subtotal Base 8:</span>
                                                    <span className="fw-semibold">
                                                        {(pagoEmitidas?.dSubTotalBase8 || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                    </span>
                                                </div>

                                                <div className="d-flex justify-content-between small fw-bold border-top pt-1">
                                                    <span className="text-secondary">IVA 16:</span>
                                                    <span className="fw-semibold">
                                                        {(pagoEmitidas?.dIva16 || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                    </span>
                                                </div>


                                                <div className="d-flex justify-content-between small fw-bold border-top pt-1">
                                                    <span className="text-secondary">IVA 8:</span>
                                                    <span className="fw-semibold">
                                                        {(pagoEmitidas?.dIva8 || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                    </span>
                                                </div>

                                                {/* Espaciador flexible que empuja el total hacia abajo */}
                                                <div className="flex-grow-1"></div>

                                                <div className="d-flex justify-content-between border-top pt-1 mt-1 fw-bold">
                                                    <span>Total:</span>
                                                    <span className="text-dark">
                                                        {(pagoEmitidas?.dTotal || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                    </span>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>


                                </div>
                            </div>
                        </Col>


                        <Col md={12}>
                            <div className="border rounded shadow-sm mt-4">
                                <h6 className="fw-bold p-2 bg-light border-bottom mb-0">FACTURAS RECIBIDAS</h6>
                                <div className="p-2">
                                    {/* Primera fila con PUE y PPD */}
                                    <Row className="mb-3">
                                        {/* Columna PUE */}
                                        <Col md={6} className="pe-1">
                                            <div className="border p-2 bg-white rounded">
                                                <small className="d-block fw-bold text-uppercase text-primary mb-2">PUE - Pago en una exhibición - INGRESO</small>

                                                <div className="d-flex justify-content-between small fw-bold">
                                                    <span className="text-secondary">Subtotal:</span>
                                                    <span className="fw-semibold">
                                                        {(facturasRecibidas.find(f => f.vMetodoPago === "PUE")?.dTotalSubTotal || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                    </span>
                                                </div>
                                                <div className="d-flex justify-content-between small fw-bold border-top pt-1">
                                                    <span className="text-secondary">Descuento:</span>
                                                    <span className="fw-semibold">
                                                        {(facturasRecibidas.find(f => f.vMetodoPago === "PUE")?.dDescuento || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                    </span>
                                                </div>

                                                <div className="mt-2">
                                                    <div className="d-flex justify-content-between small">
                                                        <span className="text-secondary">IVA:</span>
                                                        <span className="fw-semibold">
                                                            {(facturasRecibidas.find(f => f.vMetodoPago === "PUE")?.dIva || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                        </span>
                                                    </div>
                                                    <div className="d-flex justify-content-between small">
                                                        <span className="text-secondary">IEPS:</span>
                                                        <span className="fw-semibold">
                                                            {(facturasRecibidas.find(f => f.vMetodoPago === "PUE")?.dIEPS || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                        </span>
                                                    </div>
                                                </div>

                                                <div className="mt-2">
                                                    <div className="d-flex justify-content-between small">
                                                        <span className="text-secondary">IVA RET:</span>
                                                        <span className="fw-semibold">
                                                            {(facturasRecibidas.find(f => f.vMetodoPago === "PUE")?.dIvaRetenido || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                        </span>
                                                    </div>
                                                    <div className="d-flex justify-content-between small">
                                                        <span className="text-secondary">ISR RET:</span>
                                                        <span className="fw-semibold">
                                                            {(facturasRecibidas.find(f => f.vMetodoPago === "PUE")?.dIsrRetenido || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                        </span>
                                                    </div>
                                                </div>

                                                <div className="d-flex justify-content-between fw-bold small border-top pt-1">
                                                    <span className="text-secondary">Total Impuestos Trasladados:</span>
                                                    <span className="fw-semibold">
                                                        {(facturasRecibidas.find(f => f.vMetodoPago === "PUE")?.dTotalImpuestosTrasladados || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                    </span>
                                                </div>
                                                <div className="d-flex justify-content-between small fw-bold border-top pt-1">
                                                    <span className="text-secondary">Total Impuestos Retenidos:</span>
                                                    <span className="fw-semibold">
                                                        {(facturasRecibidas.find(f => f.vMetodoPago === "PUE")?.dTotalImpuestosRetenidos || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                    </span>
                                                </div>

                                                <div className="d-flex justify-content-between border-top pt-1 mt-1 fw-bold">
                                                    <span>Total:</span>
                                                    <span className="text-dark">
                                                        {(facturasRecibidas.find(f => f.vMetodoPago === "PUE")?.dTotal || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                    </span>
                                                </div>
                                            </div>
                                        </Col>

                                        {/* Columna PPD */}
                                        <Col md={6} className="ps-1">
                                            <div className="border p-2 bg-white rounded">
                                                <small className="d-block fw-bold text-uppercase text-primary mb-2">PPD - Pago parcialidades - INGRESO</small>

                                                <div className="d-flex justify-content-between small fw-bold">
                                                    <span className="text-secondary">Subtotal:</span>
                                                    <span className="fw-semibold">
                                                        {(facturasRecibidas.find(f => f.vMetodoPago === "PPD")?.dTotalSubTotal || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                    </span>
                                                </div>
                                                <div className="d-flex justify-content-between small fw-bold border-top pt-1">
                                                    <span className="text-secondary">Descuento:</span>
                                                    <span className="fw-semibold">
                                                        {(facturasRecibidas.find(f => f.vMetodoPago === "PPD")?.dDescuento || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                    </span>
                                                </div>

                                                <div className="mt-2">
                                                    <div className="d-flex justify-content-between small">
                                                        <span className="text-secondary">IVA:</span>
                                                        <span className="fw-semibold">
                                                            {(facturasRecibidas.find(f => f.vMetodoPago === "PPD")?.dIva || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                        </span>
                                                    </div>
                                                    <div className="d-flex justify-content-between small">
                                                        <span className="text-secondary">IEPS:</span>
                                                        <span className="fw-semibold">
                                                            {(facturasRecibidas.find(f => f.vMetodoPago === "PPD")?.dIEPS || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                        </span>
                                                    </div>
                                                </div>

                                                <div className="mt-2">
                                                    <div className="d-flex justify-content-between small">
                                                        <span className="text-secondary">IVA RET:</span>
                                                        <span className="fw-semibold">
                                                            {(facturasRecibidas.find(f => f.vMetodoPago === "PPD")?.dIvaRetenido || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                        </span>
                                                    </div>
                                                    <div className="d-flex justify-content-between small">
                                                        <span className="text-secondary">ISR RET:</span>
                                                        <span className="fw-semibold">
                                                            {(facturasRecibidas.find(f => f.vMetodoPago === "PPD")?.dIsrRetenido || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                        </span>
                                                    </div>
                                                </div>

                                                <div className="d-flex justify-content-between small border-top pt-1 fw-bold">
                                                    <span className="text-secondary">Total Impuestos Trasladados:</span>
                                                    <span className="fw-semibold">
                                                        {(facturasRecibidas.find(f => f.vMetodoPago === "PPD")?.dTotalImpuestosTrasladados || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                    </span>
                                                </div>
                                                <div className="d-flex justify-content-between small border-top pt-1 fw-bold">
                                                    <span className="text-secondary">Total Impuestos Retenidos:</span>
                                                    <span className="fw-semibold">
                                                        {(facturasRecibidas.find(f => f.vMetodoPago === "PPD")?.dTotalImpuestosRetenidos || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                    </span>
                                                </div>

                                                <div className="d-flex justify-content-between border-top pt-1 mt-1 fw-bold">
                                                    <span>Total:</span>
                                                    <span className="text-dark">
                                                        {(facturasRecibidas.find(f => f.vMetodoPago === "PPD")?.dTotal || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                    </span>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        {/* Columna EGRESO */}
                                        <Col md={6} className="pe-1">
                                            <div className="border p-2 bg-white rounded">
                                                <small className="d-block fw-bold text-uppercase text-primary mb-2">EGRESO - PUE - PPD</small>

                                                <div className="d-flex justify-content-between small fw-bold">
                                                    <span className="text-secondary">Subtotal:</span>
                                                    <span className="fw-semibold">
                                                        {(egresoRecibidas?.dTotalSubTotal || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                    </span>
                                                </div>
                                                <div className="d-flex justify-content-between small fw-bold border-top pt-1">
                                                    <span className="text-secondary">Descuento:</span>
                                                    <span className="fw-semibold">
                                                        {(egresoRecibidas?.dDescuento || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                    </span>
                                                </div>

                                                <div className="d-flex justify-content-between small border-top pt-1">
                                                    <span className="text-secondary">IVA:</span>
                                                    <span className="fw-semibold">
                                                        {(egresoRecibidas?.dIva || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                    </span>
                                                </div>
                                                <div className="d-flex justify-content-between small">
                                                    <span className="text-secondary">IEPS:</span>
                                                    <span className="fw-semibold">
                                                        {(egresoRecibidas?.dIEPS || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                    </span>
                                                </div>

                                                <div className="d-flex justify-content-between small fw-bold border-top pt-1">
                                                    <span className="text-secondary">Total de impuestos trasladados:</span>
                                                    <span className="fw-semibold">
                                                        {(egresoRecibidas?.dTotalImpuestosTrasladados || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                    </span>
                                                </div>

                                                <div className="d-flex justify-content-between border-top pt-1 mt-1 fw-bold">
                                                    <span>Total:</span>
                                                    <span className="text-dark">
                                                        {(egresoRecibidas?.dTotal || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                    </span>
                                                </div>
                                            </div>
                                        </Col>

                                        {/* Columna PAGO */}
                                        {/* Columna PAGO */}
                                        <Col md={6} className="ps-1">
                                            <div className="border p-2 bg-white rounded" style={{ height: "182px", display: "flex", flexDirection: "column" }}>
                                                <small className="d-block fw-bold text-uppercase text-primary mb-2">REP - RECIBO ELECTRÓNICO DE PAGO</small>

                                                <div className="d-flex justify-content-between small fw-bold">
                                                    <span className="text-secondary">Subtotal Base 16:</span>
                                                    <span className="fw-semibold">
                                                        {(pagoRecibidas?.dSubTotal16 || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                    </span>
                                                </div>
                                                <div className="d-flex justify-content-between small fw-bold">
                                                    <span className="text-secondary">Subtotal Base 8:</span>
                                                    <span className="fw-semibold">
                                                        {(pagoRecibidas?.dSubTotalBase8 || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                    </span>
                                                </div>

                                                <div className="d-flex justify-content-between small fw-bold border-top pt-1">
                                                    <span className="text-secondary">IVA 16:</span>
                                                    <span className="fw-semibold">
                                                        {(pagoRecibidas?.dIva16 || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                    </span>
                                                </div>
                                                

                                                <div className="d-flex justify-content-between small fw-bold border-top pt-1">
                                                    <span className="text-secondary">IVA 8:</span>
                                                    <span className="fw-semibold">
                                                        {(pagoRecibidas?.dIva8 || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                    </span>
                                                </div>

                                                {/* Espaciador flexible que empuja el total hacia abajo */}
                                                <div className="flex-grow-1"></div>

                                                <div className="d-flex justify-content-between border-top pt-1 mt-1 fw-bold">
                                                    <span>Total:</span>
                                                    <span className="text-dark">
                                                        {(pagoRecibidas?.dTotal || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                    </span>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        </Col>


                    {/*<Col md={6}>*/}
                    {/*    <div className="border rounded shadow-sm h-100">*/}
                    {/*        <h6 className="fw-bold p-2 bg-light border-bottom mb-0">COMPROBANTES DE EGRESO (E)</h6>*/}
                    {/*        <div className="p-2">*/}
                    {/*            <div className="bg-white p-2 rounded">*/}
                    {/*                    <div className="d-flex justify-content-between small  fw-bold">*/}
                    {/*                    <span className="text-secondary">Subtotal:</span>*/}
                    {/*                    <span className="fw-semibold">*/}
                    {/*                        {(facturasRecibidas?.dTotalSubTotal || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}*/}
                    {/*                    </span>*/}
                    {/*                </div>*/}
                    {/*                    <div className="d-flex justify-content-between small  fw-bold  border-top pt-1">*/}
                    {/*                        <span className="text-secondary">Descuento:</span>*/}
                    {/*                        <span className="fw-semibold">*/}
                    {/*                            {(facturasRecibidas?.dDescuento || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}*/}
                    {/*                        </span>*/}
                    {/*                    </div>*/}
                    {/*                    */}{/* Impuestos Trasladados desglosados */}
                    {/*                    <div className="mt-2">*/}
                    {/*                    <div className="d-flex justify-content-between small">*/}
                    {/*                        <span className="text-secondary">IVA:</span>*/}
                    {/*                        <span className="fw-semibold">*/}
                    {/*                            {(facturasRecibidas?.dIva || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}*/}
                    {/*                        </span>*/}
                    {/*                    </div>*/}
                    {/*                    <div className="d-flex justify-content-between small">*/}
                    {/*                        <span className="text-secondary">IEPS:</span>*/}
                    {/*                        <span className="fw-semibold">*/}
                    {/*                            {(facturasRecibidas?.dIEPS || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}*/}
                    {/*                        </span>*/}
                    {/*                    </div>*/}
                                        
                    {/*                </div>*/}

                    {/*                    */}{/* Impuestos Retenidos desglosados */}
                    {/*                    <div className="mt-2">*/}
                    {/*                    <div className="d-flex justify-content-between small">*/}
                    {/*                        <span className="text-secondary">IVA RET:</span>*/}
                    {/*                        <span className="fw-semibold">*/}
                    {/*                            {(facturasRecibidas?.dIvaRetenido || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}*/}
                    {/*                        </span>*/}
                    {/*                    </div>*/}
                    {/*                    <div className="d-flex justify-content-between small">*/}
                    {/*                        <span className="text-secondary">ISR RET:</span>*/}
                    {/*                        <span className="fw-semibold">*/}
                    {/*                            {(facturasRecibidas?.dIsrRetenido || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}*/}
                    {/*                        </span>*/}
                    {/*                    </div>*/}
                                       
                    {/*                </div>*/}
                    {/*                    <div className="d-flex justify-content-between small border-top pt-1  fw-bold">*/}
                    {/*                        <span className="text-secondary">Total Trasladados:</span>*/}
                    {/*                        <span className="fw-semibold">*/}
                    {/*                            {(facturasRecibidas?.dTotalImpuestosTrasladados || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}*/}
                    {/*                        </span>*/}
                    {/*                    </div>*/}
                    {/*                    <div className="d-flex justify-content-between small border-top pt-1  fw-bold">*/}
                    {/*                        <span className="text-secondary">Total Retenidos:</span>*/}
                    {/*                        <span className="fw-semibold">*/}
                    {/*                            {(facturasRecibidas?.dTotalImpuestosRetenidos || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}*/}
                    {/*                        </span>*/}
                    {/*                    </div>*/}
                    {/*                    <div className="d-flex justify-content-between border-top pt-1 mt-1 fw-bold">*/}
                    {/*                    <span>Total:</span>*/}
                    {/*                    <span className="text-dark">*/}
                    {/*                        {(facturasRecibidas?.dTotal || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}*/}
                    {/*                    </span>*/}
                    {/*                </div>*/}
                    {/*            </div>*/}
                    {/*        </div>*/}
                    {/*    </div>*/}
                    {/*</Col>*/}



                    {/*<Col md={6}>*/}
                    {/*    <div className="border rounded shadow-sm h-100">*/}
                    {/*        <h6 className="fw-bold p-2 bg-light border-bottom mb-0">COMPROBANTES DE PAGO (P)</h6>*/}
                    {/*        <div className="p-2">*/}
                    {/*            {facturasPago ? (*/}
                    {/*                <div className="bg-white p-2 rounded">*/}
                    {/*                    <div className="d-flex justify-content-between small">*/}
                    {/*                        <span className="text-secondary">Traslados Base IVA16:</span>*/}
                    {/*                        <span className="fw-semibold">*/}
                    {/*                            {(facturasPago.dTotalTrasladosBaseIVA16 || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}*/}
                    {/*                        </span>*/}
                    {/*                    </div>*/}
                    {/*                    <div className="d-flex justify-content-between small">*/}
                    {/*                        <span className="text-secondary">Traslados Impuesto IVA16:</span>*/}
                    {/*                        <span className="fw-semibold">*/}
                    {/*                            {(facturasPago.dTotalTrasladosImpuestoIVA16 || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}*/}
                    {/*                        </span>*/}
                    {/*                    </div>*/}
                    {/*                    <div className="d-flex justify-content-between border-top pt-1 mt-1 fw-bold">*/}
                    {/*                        <span>Total General:</span>*/}
                    {/*                        <span className="text-dark">*/}
                    {/*                            {(facturasPago.dSumaTotal || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}*/}
                    {/*                        </span>*/}
                    {/*                    </div>*/}
                    {/*                </div>*/}
                    {/*            ) : (*/}
                    {/*                <div className="text-center small py-2 text-muted">Sin operaciones registradas</div>*/}
                    {/*            )}*/}
                    {/*        </div>*/}
                    {/*    </div>*/}
                    {/*</Col>*/}
                        <Row className="g-3">
                            <Col md={12}>
                                <div className="border rounded shadow-sm">
                                    <h6 className="fw-bold p-2 bg-light border-bottom mb-0">RESUMEN FINANCIERO</h6>
                                    <div className="p-2">
                                        <Row>
                                            <Col md={6} className="pe-1">
                                                <div className="border p-2 bg-white rounded mb-3">
                                                    <small className="d-block fw-bold text-uppercase text-primary mb-2">INGRESOS</small>

                                                    <div className="d-flex justify-content-between small fw-bold">
                                                        <span className="text-secondary">Ingresos Acumulables:</span>
                                                        <span className="fw-semibold">
                                                            {(informe.IngresosAcumulables || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                        </span>
                                                    </div>

                                                    <div className="d-flex justify-content-between small fw-bold border-top pt-1">
                                                        <span className="text-secondary">Total IVA Causado:</span>
                                                        <span className="fw-semibold">
                                                            {(informe.TotalIvaCausado || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                        </span>
                                                    </div>

                                                    <div className="d-flex justify-content-between small fw-bold border-top pt-1">
                                                        <span className="text-secondary">Ingresos Efectivamente Cobrados:</span>
                                                        <span className="fw-semibold">
                                                            {(informe.IngresosEfectivamenteCobrados || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                        </span>
                                                    </div>

                                                    <div className="d-flex justify-content-between small fw-bold border-top pt-1">
                                                        <span className="text-secondary">Total IVA Efectivamente Cobrado:</span>
                                                        <span className="fw-semibold">
                                                            {(informe.TotalIvaEfectivamenteCobrado || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                        </span>
                                                    </div>
                                                </div>
                                            </Col>

                                            <Col md={6} className="ps-1">
                                                <div className="border p-2 bg-white rounded mb-3">
                                                    <small className="d-block fw-bold text-uppercase text-primary mb-2">GASTOS</small>

                                                    <div className="d-flex justify-content-between small fw-bold">
                                                        <span className="text-secondary">Gastos Efectuados:</span>
                                                        <span className="fw-semibold">
                                                            {(informe.GastosEfectuados || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                        </span>
                                                    </div>

                                                    <div className="d-flex justify-content-between small fw-bold border-top pt-1">
                                                        <span className="text-secondary">Total de IVA a Acreditar:</span>
                                                        <span className="fw-semibold">
                                                            {(informe.TotalIvaAcreditar || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                        </span>
                                                    </div>

                                                    <div className="d-flex justify-content-between small fw-bold border-top pt-1">
                                                        <span className="text-secondary">Gastos Efectivamente Pagados:</span>
                                                        <span className="fw-semibold">
                                                            {(informe.GastosEfectivamentePagados || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                        </span>
                                                    </div>

                                                    <div className="d-flex justify-content-between small fw-bold border-top pt-1">
                                                        <span className="text-secondary">IVA Acreditable del Periodo:</span>
                                                        <span className="fw-semibold">
                                                            {(informe.IvaAcreditablePeriodo || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                        </span>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col md={12}>
                                                <div className="border p-2 bg-white rounded">
                                                    <small className="d-block fw-bold text-uppercase text-primary mb-2">TOTALES DE IMPUESTOS</small>

                                                    <div className="d-flex justify-content-between small fw-bold">
                                                        <span className="text-secondary">Total de IVA a Pagar:</span>
                                                        <span className="fw-semibold text-dark">
                                                            {(informe.TotalIvaPagar || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                        </span>
                                                    </div>

                                                    <div className="d-flex justify-content-between small fw-bold border-top pt-1">
                                                        <span className="text-secondary">Total de IVA Retenido:</span>
                                                        <span className="fw-semibold">
                                                            {(informe.TotalIvaRetenido || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                        </span>
                                                    </div>

                                                    <div className="d-flex justify-content-between small fw-bold border-top pt-1">
                                                        <span className="text-secondary">Total de ISR Retenido:</span>
                                                        <span className="fw-semibold">
                                                            {(informe.TotalISRRetenido || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                        </span>
                                                    </div>

                                                    
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                            </Col>
                        </Row>

                </Row>
            )}
        </Container>
    );
};


export default ResumenMensualImpuestos;